// Tyler.Api.Metadata.MetadataSummary
export enum MetadataSummary {
    Sum = 1,
    Count = 2,
    Average = 3
}
